<template>
<div>
  <!--通用头部-->
  <Header></Header>

  <div class="container" style="height: 100%; border: 1px solid #eee">
    
    <!-- <el-aside style="background-color:#409EFF;display: flex;;width:100%;border-top:1px solid rgb(84, 92, 100);border-bottom:1px solid rgb(84, 92, 100)">
      <el-menu
        :default-active="active"
        class="el-menu-vertical-demo"
        @open="handleOpen"
        @close="handleClose"
        @select="select"
        background-color="#409EFF"
        text-color="#fff"
        active-text-color="#fdda5a"
      >
      <template v-for="item in menus">
        <el-menu-item :index="item.index" :key="item.index">
          <i :class="item.icon"></i>
          <span slot="title">{{item.title}}</span>
        </el-menu-item>
      </template>
      </el-menu>
    </el-aside> -->
	
    <el-container>
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>

  </div>
  <!--通用头部-->
  <Footer></Footer>
  </div>
</template>



<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'

export default {
  name: "mainContent",
  components:{
    Header,
    Footer
  },
  data() {
    return {
      username: '',
      userInfo: {},
      active: '/main/home',
      
      menus: [
        {
          index: "/main/home",
          icon: "el-icon-location",
          title: "HOME",
        },
        {
          index: "/main/help",
          icon: "el-icon-help",
          title: "HELP",
        },
        {
          index: "/main/search",
          icon: "el-icon-search",
          title: "SEARCHBYSMILE",
        },
        {
          index: "/main/searchBytar",
          icon: "el-icon-search",
          title: "SEARCHBYTARGET",
        },
        {
          index: "/main/predict",
          icon: "el-icon-search",
          title: "PREDICT",
        },
        // {
        //   index: '',
        //   icon: "el-icon-setting",
        //   title: "USER",
        // },
      ],
    };
  },
  watch: {
    $route: {
      handler({ fullPath }) {
        let i = this.menus.find(item => {
          return fullPath.includes(item.index); 
        });
       
        if (i) {
          this.active = i.index;
        } else {
          this.active = fullPath;
        }
      },
      immediate: true,
    },
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    select(key) {
      console.log(key);
      this.$router.replace({
        path: key,
      });
    },
    // logout() {
    //   this.$http({
    //     url: '/api/user/logout',
    //     method: 'get'
    //   }).then(res => {
    //     window.location.reload()
    //   });
    // }
  },
  mounted() {
    // this.$http({
    //   url: '/api/getUserName',
    //   method: 'get'
    // }).then(res => {
    //   this.username = res.data.data;
    //   this.menus[5].index = `/main/user?username=${this.username}`
    //   if (!this.username) {
    //     this.$router.push({
    //       path: '/login'
    //     });
    //   }
    // });
  }
};
</script>

<style scoped>
.logo {
  height: 83.5px !important;
  width: 381.5px;
  margin-left: 18%;
  margin-top: 10px;
}
.container {
  display: flex;
  flex-direction: column ;
}
.el-menu-vertical-demo {
  border-right: none;
  display: flex;
  margin-left:20%;
  background-color:#409EFF;
}
  .left {
    height: 100vh;
    background: #555c65;
  }
  .main-warp {
    height: 100%;
  }
  .header-content-warp {
    display: flex;
    justify-content: space-between;
    border-bottom: 2px solid #fff;
  }
  .logo {
    display: flex;
    align-items: center;
    height: 100%;
    color: #fff;
    font-size: 20px;
  }
  .username {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 100%;
    color: #fff;
  }
  .rt-10 {
    margin-right: 10px;
  }
  .feet {
    width: 100%;
    margin: 0 auto;
    background-color:#409EFF;
    height: 50px;
  }
  .feettext {
    width: 1200px;
    margin: 0.5ex auto;
    color:#faf5ea;
    font-size: 15px;
  }
  .block{
    width: 1200px;
    margin-top: 0.5ex auto;
    color:#faf5ea;
    font-size: 15px;
  }
</style>